<div *ngIf="editable">
  <p-checkbox
    [name]="fieldName"
    [disabled]="!editable"
    [binary]="true"
    [(ngModel)]="rowData[fieldName]"
    ngClass="center-checkbox"
    (onChange)="completeCellEdit.emit({ data: rowData, field: fieldName })"
    (click)="$event.stopPropagation()"
    jmlStopClickPropagation
    jmlClickOutside
  ></p-checkbox>
</div>
<div *ngIf="!editable">
  <i *ngIf="rowData[fieldName]" class="pi pi-check"></i>
  <i *ngIf="!rowData[fieldName]" class="fa-regular fa-square fa-lg"></i>
</div>
<!--div *ngIf="!isEdited" class="cell-view">
    <i *ngIf="rowData[fieldName]" class="pi pi-check"></i>
    <i *ngIf="!rowData[fieldName]" class="pi pi-times"></i>
    <div class="flex">
        <i *ngIf="!mandatory && editable" id="cancelRowSelection" data-cy="BoolCell_Button_cancel" class="pi pi-times cell-edit-icon" (edit)="onDelete()"></i>
        <i *ngIf="editable" id="cancelRowSelection" data-cy="BoolCell_Button_edit" class="pi pi-pencil cell-edit-icon" (edit)="originalContent = rowData[fieldName]; isEdited = true;"></i>
    </div>
</div-->
